import PropTypes from "prop-types";
import React from "react";
import Swiper, { SwiperSlide } from "../../components/swiper";
import categoryData from "../../data/category/category-two.json";
import CategoryTwoSingle from "../../components/category/CategoryTwoSingle.js";
import SectionTitleFour from "../../components/section-title/SectionTitleFour.js";

const CategoryTwoSlider = ({ block }) => {
  // swiper slider settings
  const settings = {
    loop: false,
    spaceBetween: 30,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    breakpoints: {
      992: {
        slidesPerView: 4
      },
      576: {
        slidesPerView: 3
      },
      320: {
        slidesPerView: 1
      }
    }
  };
  return (
    <div
      className={`collections-area ${block.spaceTopClass ? block.spaceTopClass : ""}  ${
        block.spaceBottomClass ? block.spaceBottomClass : ""
      }`}
    >
      <div className="container">
        {/* section title */}
        <SectionTitleFour titleText={block?.title} spaceBottomClass="mb-40" />
        <div className="collection-wrap">
          <div className="collection-active">
            <Swiper options={settings}>
              {block?.componentData?.map((single, key) => {
                  return (
                    <SwiperSlide key={key}>
                      <CategoryTwoSingle
                        data={single}
                        key={key}
                        sliderClass="swiper-slide"
                      />
                    </SwiperSlide>
                  );
                })}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};

CategoryTwoSlider.propTypes = {
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string
};

export default CategoryTwoSlider;
